import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 16px;
  gap: 24px;
`;

const PageTitleDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-size: 24px;
  font-weight: 700;
  color: #222222;
  align-items: center;
  justify-content: center;
`;

const PageTitleDescription = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #616161;
`;

const ReciptDiv = styled.div`
  width: 100%;
  padding: 24px;
  border-radius: 20px;
  border: 1px solid #e5e8ea;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Blue100Button = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  background-color: #008aff;
  padding: 14px 28px;
  cursor: pointer;
`;

const Div50016Light = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #616161;
`;

const Div50016 = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #222222;
  //min-width: 164px;
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: end;
`;

const Div70014 = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #222222;
`;

const Span50016Dark = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #000000;
`;

const Span70020 = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: #222222;
`;

const Span70024 = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: #222222;
`;

const Span50014Light = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #616161;
`;

const GrayLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e5e8ea;
`;

export const s = {
  Container,
  PageTitleDiv,
  PageTitleDescription,
  ReciptDiv,
  Blue100Button,
  GrayLine,
  Div50016Light,
  Div50016,
  Div70014,
  Span50016Dark,
  Span70020,
  Span70024,
  Span50014Light,
};
